var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaggisar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: 48,
    viewBox: "0 0 391 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.357 29.5L0 0V48H390.436V17.5439L286.455 41.8057L242.379 17.5439L215.994 29.5L136.516 17.5439L117.357 29.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaggisar);
export default __webpack_public_path__ + "static/media/Taggisar.07005f7157c5be5e76b2908d475edd74.svg";
export { ForwardRef as ReactComponent };